// extracted by mini-css-extract-plugin
export var label = "_eb-2";
export var slideContainer = "_eb-0";
export var slider = "_eb-1";